import clsx from 'clsx';
import type { ReactElement } from 'react';

import type { DeckAiAssessment } from '@mtgcraft/shared';
import { COMMANDER_BRACKET_LABELS } from '@mtgcraft/shared';

export interface DeckAiBadgeProps {
  assessment: DeckAiAssessment;
  /** Makes the badge a button that reopens the full assessment */
  onClick?: () => void;
  className?: string;
}

const BASE_CLASSES = 'border-storm bg-slate/60 text-silver inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs';

export default function DeckAiBadge({ assessment, onClick, className }: DeckAiBadgeProps): ReactElement {
  const bracketLabel =
    assessment.bracket !== null ? `Bracket ${assessment.bracket} · ${COMMANDER_BRACKET_LABELS[assessment.bracket]}` : null;

  const content = (
    <>
      <span className="text-pearl font-semibold tabular-nums">{assessment.power_level}/10</span>
      {bracketLabel && <span className="text-ash">· {bracketLabel}</span>}
    </>
  );

  if (!onClick) {
    return (
      <span title={assessment.summary} className={clsx(BASE_CLASSES, className)}>
        {content}
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      title="View the full AI assessment"
      className={clsx(BASE_CLASSES, 'hover:border-aether/60 hover:bg-slate focus-ring transition-colors', className)}
    >
      {content}
    </button>
  );
}
